import React from "react";

export default function AppPrivacyPolicy() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content">
        <div className="legal-header">
          <img
            src="/logo.png"
            alt="Auto Shiny Counter Logo"
            className="app-logo"
          />
          <h1 className="title">App Privacy Policy</h1>
          <p className="legal-date">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Auto Shiny Counter App Privacy Policy</h2>
            <p>
              This privacy policy describes how Auto Shiny Counter ("the App")
              handles your information. We are committed to protecting your
              privacy and ensuring transparency about our data practices.
            </p>
          </section>

          <section className="legal-section">
            <h2>Information We Collect</h2>
            <p>
              <strong>Camera Access:</strong> The App requires camera access to
              automatically count resets by analyzing your screen. All camera
              processing happens locally on your device. We do not store,
              transmit, or share any images or video from your camera.
            </p>
            <p>
              <strong>Reset Counts:</strong> The App stores your reset counts
              locally on your device. This data is never transmitted to our
              servers or shared with third parties.
            </p>
            <p>
              <strong>App Settings:</strong> Your app preferences and settings
              are stored locally on your device.
            </p>
          </section>

          <section className="legal-section">
            <h2>How We Use Your Information</h2>
            <p>
              • <strong>Camera Data:</strong> Used solely for real-time reset
              counting. No images are saved or processed beyond the immediate
              counting function.
            </p>
            <p>
              • <strong>Reset Counts:</strong> Used to display your current
              progress and maintain your hunting statistics.
            </p>
            <p>
              • <strong>Settings:</strong> Used to personalize your app
              experience.
            </p>
          </section>

          <section className="legal-section">
            <h2>Data Storage and Security</h2>
            <p>
              • All data is stored locally on your device using secure,
              industry-standard encryption
            </p>
            <p>• No data is transmitted to external servers</p>
            <p>• No cloud storage or backup services are used</p>
            <p>• Your data remains under your complete control</p>
          </section>

          <section className="legal-section">
            <h2>Third-Party Services</h2>
            <p>The App may integrate with:</p>
            <p>
              • <strong>App Store Services:</strong> For app updates and
              purchases (handled by Apple/Google)
            </p>
            <p>
              These services have their own privacy policies, and we encourage
              you to review them.
            </p>
          </section>

          <section className="legal-section">
            <h2>Your Rights and Choices</h2>
            <p>
              • <strong>Camera Access:</strong> You can disable camera access in
              your device settings, though this will limit the app's automatic
              counting functionality
            </p>
            <p>
              • <strong>Data Deletion:</strong> You can delete all app data by
              uninstalling the app
            </p>
            <p>
              • <strong>Manual Mode:</strong> You can use the app in manual
              counting mode without camera access
            </p>
          </section>

          <section className="legal-section">
            <h2>Children's Privacy</h2>
            <p>
              The App does not knowingly collect personal information from
              children under 13. If you are a parent and believe your child has
              provided us with personal information, please contact us.
            </p>
          </section>

          <section className="legal-section">
            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of any material changes through the app or app store
              updates. Your continued use of the App after changes constitutes
              acceptance of the updated policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our data
              practices, please contact us at:
              <br />
              <a href="mailto:sebastian-wagner-96@gmx.de">
                sebastian-wagner-96@gmx.de
              </a>
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
